import { createFileRoute } from '@tanstack/react-router';

import { usePermissions } from '../modules/iam/permissions-context.js';

// eslint-disable-next-line react-refresh/only-export-components
function HomePage() {
  const { permissions, loading } = usePermissions();

  if (!loading && !permissions.length) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[60vh] gap-2 text-center">
        <p className="text-lg font-semibold">No roles assigned</p>
        <p className="text-sm text-muted-foreground">
          Your account has not been assigned any roles yet. Contact your administrator to get
          access.
        </p>
      </div>
    );
  }

  return <div>Home</div>;
}

export const Route = createFileRoute('/')({
  component: HomePage,
});
